<template>
  <component
    :is="type"
    class="button is-text"
    :to="to"
    @click="$emit('onClick')"
  >
    <div>
      <slot />
    </div>
    <div
      v-if="icon_fontawesome"
      class="icon text-gray-500"
    >
      <FontAwesomeIcon :icon="icon_fontawesome" />
    </div>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { BUTTON_LINK_ACTIONS_TO_FONTAWESOME_ICON } from '@/app/data/button_constants';

const props = defineProps({
  to: { type: Object, default: null },
  action: {
    type: String,
    default: null,
    validator: (prop) => Object.keys(BUTTON_LINK_ACTIONS_TO_FONTAWESOME_ICON).includes(prop),
  },
});

defineEmits(['onClick']);

const type = computed(() => (props.to ? 'AppLink' : 'button'));

const icon_fontawesome = computed(() => BUTTON_LINK_ACTIONS_TO_FONTAWESOME_ICON[props.action]);
</script>
